import { render, staticRenderFns } from "./inviteregist.vue?vue&type=template&id=6a9e79ec&scoped=true"
import script from "./inviteregist.vue?vue&type=script&lang=js"
export * from "./inviteregist.vue?vue&type=script&lang=js"
import style0 from "./inviteregist.vue?vue&type=style&index=0&id=6a9e79ec&prod&lang=scss&scoped=true"
import style1 from "./inviteregist.vue?vue&type=style&index=1&id=6a9e79ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9e79ec",
  null
  
)

export default component.exports